const Theme = {
  logo_image_url: 'palaisprod.png',
  logo_height: 100,

  button_color: '#62bc49',
  button_text_color: '#343434',
  button_half_border_color: '#62bc49',

  text_font: `'Roboto', sans-serif`,
  title_font: `'Roboto', sans-serif`,
}

export default Theme
